export const MAX_SCHEDULE_ROWS = 14;
export function parseScheduleRows(value) {
    if (!value)
        return [];
    return value
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean)
        .slice(0, MAX_SCHEDULE_ROWS)
        .map((line) => {
        const sep = line.indexOf("|");
        if (sep === -1)
            return { time: "", text: line };
        return {
            time: line.slice(0, sep).trim(),
            text: line.slice(sep + 1).trim(),
        };
    })
        .filter((row) => row.time !== "" || row.text !== "");
}
export function parseTableRows(value) {
    if (!value)
        return [];
    return value
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean)
        .slice(0, MAX_SCHEDULE_ROWS)
        .map((line) => line.split("|").map((cell) => cell.trim()));
}
export function parseImageList(value, max = 12) {
    if (!value)
        return [];
    return value
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean)
        .slice(0, max);
}
export function hasTimes(rows) {
    return rows.some((r) => r.time !== "");
}
